{
  "page": {
    "title": "Modèles",
    "subtitle": "Gérez les modèles de produits partagés et leurs règles de validation. Tous les administrateurs voient chaque modèle.",
    "regionErrors": "Erreurs de zone",
    "newTemplate": "+ Nouveau modèle"
  },
  "filters": {
    "search": "Rechercher",
    "searchPlaceholder": "Rechercher par code, nom, alias…",
    "status": "Statut",
    "statusAll": "Tous",
    "statusActive": "Actif",
    "statusInactive": "Inactif",
    "type": "Type",
    "typeAll": "Tous les types",
    "typePrint": "Impression",
    "typeEmbroidery": "Broderie",
    "productKind": "Type de produit",
    "productKindAll": "Tous les types de produit",
    "productKindApparel": "Vêtements",
    "productKindHomeDecor": "Décoration",
    "material": "Matériau",
    "materialAll": "Tous les matériaux",
    "materialFabric": "Tissu",
    "materialWood": "Bois",
    "materialMirrorAcrylic": "Acrylique miroir",
    "materialFrostedAcrylic": "Acrylique dépoli",
    "materialClearAcrylic": "Acrylique transparent",
    "showDeleted": "Afficher supprimés"
  },
  "table": {
    "selectAll": "Sélectionner toutes les lignes de cette page",
    "selectRow": "Sélectionner le modèle {{code}}",
    "code": "Code",
    "name": "Nom",
    "productKind": "Type de produit",
    "partCount": "Pièces",
    "layerCount": "Calques",
    "regionCount": "Zones",
    "status": "Statut",
    "updated": "Mis à jour",
    "actions": "Actions"
  },
  "status": {
    "active": "Actif",
    "inactive": "Inactif",
    "deleted": "Supprimé"
  },
  "rowActions": {
    "restore": "Restaurer",
    "toggleActiveLabel": "Activer/désactiver pour {{code}}",
    "on": "Activé",
    "off": "Désactivé"
  },
  "bulk": {
    "selectedCount": "{{n}} sélectionné(s)",
    "activate": "Activer",
    "deactivate": "Désactiver",
    "export": "Exporter"
  },
  "empty": "Aucun modèle ne correspond aux filtres actuels.",
  "toasts": {
    "activated": "Modèles activés",
    "deactivated": "Modèles désactivés",
    "activatedDesc": "{{modified}} modèle(s) activé(s)",
    "activatedPartialDesc": "{{modified}} activé(s) ({{already}} déjà actif(s))",
    "deactivatedDesc": "{{modified}} modèle(s) désactivé(s)",
    "deactivatedPartialDesc": "{{modified}} désactivé(s) ({{already}} déjà inactif(s))",
    "bulkActivateFailed": "Échec de l'activation groupée",
    "bulkDeactivateFailed": "Échec de la désactivation groupée",
    "exportReady": "Export prêt",
    "exportReadyDesc": "{{count}} sur {{requested}} modèle(s) sélectionné(s) exporté(s)",
    "exportReadyAllDesc": "Tous les {{count}} modèle(s) exporté(s)",
    "exportFailed": "Échec de l'export",
    "templateActivated": "Modèle activé",
    "templateDeactivated": "Modèle désactivé",
    "activateFailed": "Échec de l'activation",
    "deactivateFailed": "Échec de la désactivation",
    "restored": "Modèle restauré",
    "restoreFailed": "Échec de la restauration"
  },
  "confirmToggle": {
    "activateTitle": "Activer le modèle ?",
    "deactivateTitle": "Désactiver le modèle ?",
    "activateDesc": "Réactiver le modèle « {{name}} » ({{code}}). Le modèle apparaîtra partout où il est utilisé.",
    "deactivateDesc": "Désactiver le modèle « {{name}} » ({{code}}). Les surfaces utilisant ce modèle seront masquées temporairement jusqu'à réactivation.",
    "activateConfirm": "Activer",
    "deactivateConfirm": "Désactiver",
    "cancel": "Annuler",
    "deactivateDescInUse": "Désactiver le template « {{name}} » ({{code}}) ? Il est utilisé par {{blueprints}} blueprint(s) et {{skus}} SKU — {{names}}{{more}}. Ces SKU perdent ce template, et un blueprint sans zone d’impression ne peut pas être mis en vente."
  },
  "createDialog": {
    "title": "Nouveau template",
    "subtitle": "Créer un template minimal (code + nom EN + type). Ajoutez les régions / règles de validation plus tard sur la page de détail.",
    "codeLabel": "Code *",
    "codeHint": "Uniquement a-z, A-Z, 0-9, tiret bas ou trait d'union (1-50 caractères).",
    "nameLabel": "Nom (EN) *",
    "typeLabel": "Type *",
    "cancel": "Annuler",
    "submit": "Créer",
    "submitting": "Création…",
    "successTitle": "Template créé",
    "errorTitle": "Échec de la création du template"
  },
  "inUse": {
    "title": "Ce template est utilisé",
    "description": "Il est référencé par {{blueprints}} blueprint(s) et {{skus}} SKU. Le désactiver le retire du sélecteur de template des SKU.",
    "blueprintLevel": "S'applique à tout le blueprint",
    "skuList": "SKU : {{skus}}",
    "consequence": "Les zones d'impression sont dérivées des templates du SKU, et un blueprint sans zone d'impression ne peut pas être mis en vente. Les commandes existantes ne sont pas affectées.",
    "cancel": "Le garder actif",
    "confirm": "Désactiver quand même",
    "working": "Désactivation…"
  },
  "notReady": {
    "perTemplate": "{{code}} : {{reasons}}",
    "andMore": "…et {{n}} autre(s) template(s)",
    "TEMPLATE_ACTIVE_NO_PART": "n'a aucune zone d'impression — ajoutez au moins une zone, ou une partie avec un calque artwork",
    "TEMPLATE_ACTIVE_PART_NO_LAYER": "une partie n'a aucun calque — ajoutez au moins un calque",
    "TEMPLATE_ACTIVE_NO_ARTWORK_LAYER": "n'a aucun calque artwork, rien ne peut donc y être imprimé",
    "TEMPLATE_LAYER_ARTWORK_NO_REGION": "un calque artwork n'a aucune zone d'impression dimensionnée",
    "TEMPLATE_LAYER_ARTWORK_NO_FILE": "un calque artwork n'a aucun fichier"
  }
}
